import * as AWS from "aws-sdk";
import * as JSZip from "jszip";
import * as FileSaver from "file-saver";
import { DatePipe } from "@angular/common";
import { Component } from "@angular/core";

export class emaUtils {
   fixDecimals(num: number, decimals: number) {
    let num_ = num + "";
    let dec = num_.split(".");
    //console.log("fixDecimals ", num_);
    let ret_dec;
    let dec_size = 0;
    if (dec.length > 1) {
      ret_dec = dec[0] + "." + dec[1] + "";
      dec_size = dec[1].length;
    } else {
      ret_dec = dec[0] + ".";
    }
    if (dec_size > 2) {
      ret_dec = num.toFixed(2);
    } else {
      for (let i = 0 + dec_size; i < decimals; i++) {
        ret_dec += "0";
      }
    }

    return ret_dec; // Return the value
  }
    formatQuantity(currency_: string, amount) {
    let format_ = "";
    if (currency_ == "MXN") {
      format_ = "es-MX";
    } else {
    }
    //https://developer.mozilla.org/es/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
    //Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(monto)
    return Intl.NumberFormat(format_, {
      style: "currency",
      currency: currency_,
    }).format(amount);
  }
  formatQuantityWithNoSign(currency_: string, amount) {
    let format_ = "";
    if (currency_ == "MXN") {
      format_ = "es-MX";
    } else {
    }
    //https://developer.mozilla.org/es/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
    //Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(monto)
    return Intl.NumberFormat(format_, {
      style: "currency",
      currency: currency_,
    })
      .format(amount)
      .replace("$", "");
  }
  date_ = new Date();
  getDateAndTime3(option: string): string {
   const date = new Date();
    if (option === "date") {
      return (
        date.getFullYear().toString() +
        "-" +
        this.padWithZeroes((date.getMonth() + 1).toString(), 2) +
        "-" +
        this.padWithZeroes(date.getDate().toString(), 2)
      );
    } else if (option === "time") {
      return (
        this.padWithZeroes(date.getHours().toString(), 2) +
        ":" +
        this.padWithZeroes(date.getMinutes().toString(), 2)
        //":" +
        //this.padWithZeroes(this.date_.getSeconds().toString(), 2)
      );
    } else if (option === "year") {
      return date.getFullYear().toString();
    }
    return ""; // Si el valor de option no es válido, devolvemos una cadena vacía (opcional)
  }
  getDateAndTime2(option: string): string {
    if (option === "date") {
      return (
        this.date_.getFullYear().toString() +
        "-" +
        this.padWithZeroes((this.date_.getMonth() + 1).toString(), 2) +
        "-" +
        this.padWithZeroes(this.date_.getDate().toString(), 2)
      );
    } else if (option === "time") {
      return (
        this.padWithZeroes(this.date_.getHours().toString(), 2) +
        ":" +
        this.padWithZeroes(this.date_.getMinutes().toString(), 2)
        //":" +
        //this.padWithZeroes(this.date_.getSeconds().toString(), 2)
      );
    } else if (option === "year") {
      return this.date_.getFullYear().toString();
    }
    return ""; // Si el valor de option no es válido, devolvemos una cadena vacía (opcional)
  }

  validatePhoneNumber(phone: string){
    if (!phone || phone.trim() == "") {
      return false;
    }

    // Limpiar espacios
    const cleaned = phone;

    // Expresión flexible para teléfonos mexicanos de 10 dígitos
    const phoneRGEX =
      /^(\d{10}|[(]{0,1}\d{3}[)]{0,1}[-\s\.]{0,1}\d{3}[-\s\.]{0,1}\d{4})$/;

    return phoneRGEX.test(cleaned);
  }

  encPassword = "mateos_$";
  validateEmail(emailField: string) {
    // Define our regular expression.
    let validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;

    // Using test we can check if the text match the pattern
    if (validEmail.test(emailField)) {
      return true;
    } else {
      return false;
    }
  }
  padWithZeroes(number, length) {
    var my_string = "" + number;
    while (my_string.length < length) {
      my_string = "0" + my_string;
    }

    return my_string;
  }
  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return "#" + ("000000" + color).slice(-6);
  }
  ageCaltulator(birthdate) {
    var today = new Date();
    var birthdate_ = new Date(birthdate);
    var age_ = today.getFullYear() - birthdate_.getFullYear();
    var m = today.getMonth() - birthdate_.getMonth();
    // console.log(age_ + " m " + m);
    if (m < 0 || (m === 0 && today.getDate() < birthdate_.getDate())) {
      age_--;
    }

    return age_;
  }
  stringMatching(text: string, patern: string) {
    var kmp = require("kmp");

    // console.log(kmp(('CV ADAN MATEOS HERNANDEZ').toLowerCase(), ('').toLowerCase())); // 13
  }
  validityDateValidation(start_date, end_date, validity_type) {
    let date_mng = new DatePipe("en-US");
    let today_ = new Date();
    //console.log("start_date " + start_date);

    let today_str = date_mng.transform(today_, "yyyy-MM-dd");
    let sater_date_ = date_mng.transform(start_date, "yyyy-MM-dd");
    let end_date_ = date_mng.transform(end_date, "yyyy-MM-dd");

    let day_end_ = new Date(end_date).getTime();
    let days_start = new Date(start_date).getDay() - new Date().getDay();
    let days_end = new Date().getDay() - new Date(end_date).getDay();
    ////////////////////

    var millisecondsPerDay = 1000 * 60 * 60 * 24;
    var millisBetween = day_end_ - new Date(today_str).getTime();
    var days = millisBetween / millisecondsPerDay;
    //////////////////////
    //console.log("end_date " + end_date+ " - today_ " + today_str + " dt1[2] >>>>>>>>> days = "  + days);
    if (validity_type == "start") {
      return days;
    } else if (validity_type == "end") {
      return days;
    }
  }
  getSignedUrlAWS(bucket, pathFile): string {
    const aws = require("aws-sdk");
    let s3 = new AWS.S3({
      accessKeyId: "AKIAZI5VJPNY4HKDNAEK",
      secretAccessKey: "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",
      region: "us-east-2",
    });
    const url = s3.getSignedUrl("getObject", {
      Bucket: bucket,
      Key: pathFile,
      Expires: 8000,
      ResponseContentType: "application/pdf",
    });
    return url;
  }

  getUserData(option: string) {
    if (option == "id-and-name") {
    } else if (option == "user-id") {
      return localStorage.getItem("user_id");
    } else if (option == "name") {
      return localStorage.getItem("username_enc_admin");
    }
  }

  async documentsDownloading(folder_name, filesList) {
    const zip = new JSZip();
    const name = folder_name + ".zip";
    let files_: any[];

    for (let i = 0; i < filesList.length; i++) {
      let file_url = this.getSignedUrlAWS(
        filesList[i].bucket_name,
        filesList[i].key
      );
      //console.log("file to download: " + this.documentsGeneral[i].filename_path);
      const element = filesList[i].original_file_name;
      const file_data: any = await fetch(file_url).then((res) => res.blob());

      var binaryData = [];
      binaryData.push(file_data);
      const url: any = new Blob(binaryData, { type: "application/pdf" });
      zip.file(
        folder_name + "/" + filesList[i].file_track_name + "/" + element,
        url
      );
    }

    zip.generateAsync({ type: "blob" }).then((content) => {
      if (content) {
        FileSaver.saveAs(content, name);
      }
    });

    //   let filename = original_file_name;
    //return dataURL;
    /*
    var binaryData = [];
    binaryData.push(data);
    window.URL.createObjectURL(new Blob(binaryData, {type: "application/zip"}))
    */
    /* if(navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1){
      window.open(file_url);
    }else{
      let blob = dataURL;
      /*var binaryData = [];
      binaryData.push(dataURL);
      let url = window.URL.createObjectURL(new Blob(binaryData, {type: "application/pdf"}));
      let a = document.createElement('a');
      a.href = url;
      a.download = filename;
      //document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);*/

    //}
  }
  cleanCache() {
    //console.log("User is logged - " + localStorage.getItem("'user"));
    localStorage.setItem("session_active_admin", "inactive");

    localStorage.removeItem("username_enc_admin");
    localStorage.removeItem("psw_enc_admin");

    sessionStorage.removeItem("access_token_admin");
    sessionStorage.removeItem("refresh_token_admin");
    sessionStorage.removeItem("menu");
    localStorage.removeItem("customer");
    localStorage.removeItem("customerBranch");
    localStorage.removeItem("user");
    localStorage.removeItem("branch_office_name");
    localStorage.removeItem("menu");
    localStorage.removeItem("submenu");
    localStorage.removeItem("esEmpleado");
    localStorage.removeItem("company1_id");
    localStorage.removeItem("company_branch_id");
    localStorage.removeItem("customerBranchId");
    //Se elimina menu
    localStorage.removeItem("titleMenu");
    localStorage.clear();
    sessionStorage.clear();
  }
  /*  convertText(conversion:string, plainText:string, encryptText: string) {
    if (conversion == "encrypt") {
      return  CryptoJS.AES.encrypt(plainText.trim(), this.encPassword.trim()).toString();
    }
    else {
      return  CryptoJS.AES.decrypt(encryptText.trim(), this.encPassword.trim()).toString(CryptoJS.enc.Utf8);
    }
  }*/
}
